import React from "react";
import { useAuth } from "../contexts/AuthContext";

/**
 * Render children only when the current user holds at least one of `roles`.
 *
 * Renders `fallback` (default: nothing) otherwise. Frontend role gating is
 * defense-in-depth only — backend MUST also enforce on every mutation and
 * privileged GET. See:
 *   FederateX_agent_sync/Decisions/2026-05-16_frontend_backend_contract_decisions.md §5
 *
 * Shipped in Phase F1 with no F1 consumers; F2/F4 will use it for imaging form
 * activation and central_demo preview gating.
 *
 * @param {Object} props
 * @param {string | string[]} props.roles
 * @param {React.ReactNode} props.children
 * @param {React.ReactNode=} props.fallback
 */
const RequireRole = ({ roles, children, fallback = null }) => {
  const { hasRole } = useAuth();
  const required = Array.isArray(roles) ? roles : [roles];
  const allowed = required.some((r) => hasRole?.(r));
  return allowed ? <>{children}</> : <>{fallback}</>;
};

export default RequireRole;
